

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const CONNECTIONREQUESTSFROMUSER= createAsyncThunk(
  "connectionRequestsFromUser/connectionRequestsFromUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const connectionRequestsFromUserSlice = createSlice({
  name: "connectionRequestsFromUserSlice",
  initialState: {
    connectionRequestsFromUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfconnectionRequestsFromUser: (state) => {
        state.connectionRequestsFromUser.loading = false
        state.connectionRequestsFromUser.error = false
        state.connectionRequestsFromUser.data = []
        state.connectionRequestsFromUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CONNECTIONREQUESTSFROMUSER.fulfilled, (state, action) => {
      state.connectionRequestsFromUser = {
        ...state.connectionRequestsFromUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONREQUESTSFROMUSER.pending, (state, action) => {
      state.connectionRequestsFromUser = {
        ...state.connectionRequestsFromUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONREQUESTSFROMUSER.rejected, (state, action) => {
      state.connectionRequestsFromUser = {
        ...state.connectionRequestsFromUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const connectionRequestsFromUserAction = {
    CONNECTIONREQUESTSFROMUSER,
};

export { connectionRequestsFromUserAction };
export default connectionRequestsFromUserSlice.reducer;
export const {setInitialStateOfconnectionRequestsFromUser} = connectionRequestsFromUserSlice.actions